import React from 'react';
import { getInitials, getDisplayName, getRoleTitle, toTitleCase } from './helpers';

/**
 * NameCell — modern staff identity cell for the report tables.
 * Avatar initials + title-cased name + optional role/title badge.
 * Pure presentation: no data/sorting/search logic. `name` is the raw
 * ProviderName string (e.g. "gangothri thrivedi - MD").
 */
const NameCell = ({ name = '', openable = false, onClick }) => {
  const display = toTitleCase(getDisplayName(name)) || '-';
  const role = getRoleTitle(name);
  return (
    <div
      className={`ptd-namecell ${openable ? 'is-openable' : ''}`}
      onClick={onClick}
      title={display}
    >
      <span className="ptd-namecell-avatar">{getInitials(name)}</span>
      <span className="ptd-namecell-name">{display}</span>
      {role ? <span className="ptd-namecell-badge">{role}</span> : null}
    </div>
  );
};

export default NameCell;
